function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default class IntervalTicker {
  constructor(startTimestamp, endTimestamp, onTick, onComplete) {
    _defineProperty(this, "onTick", void 0);

    _defineProperty(this, "onComplete", void 0);

    _defineProperty(this, "timeRemaining", 0);

    _defineProperty(this, "intervalId", void 0);

    _defineProperty(this, "startTimestamp", void 0);

    _defineProperty(this, "endTimestamp", void 0);

    this.onTick = onTick;
    this.onComplete = onComplete;
    this.startTimestamp = startTimestamp;
    this.endTimestamp = endTimestamp;
  }

  start() {
    // calculate the remaining time
    this.timeRemaining = this.endTimestamp - this.startTimestamp;
    this.timeRemaining > 0 && this.run();
  }

  complete() {
    if (typeof this.onComplete === 'function') {
      this.onComplete();
    }
  }

  update() {
    this.onTick(this.timeRemaining);
  }

  run() {
    // update the countdown
    this.update(); //  setup a timer

    this.intervalId = setInterval(() => {
      // update the timer
      this.timeRemaining -= 1000;

      if (this.timeRemaining < 0) {
        // call the callback
        this.complete(); // clear the interval if expired

        this.intervalId && clearInterval(this.intervalId);
      } else {
        this.update();
      }
    }, 1000);
  }

  clear() {
    this.intervalId && clearInterval(this.intervalId);
  }

}